<template>
  <div>
    <v-row class="ma-0">
      <v-col cols="12">
        <h2 class="primary--text font-weight-bold pt-5 pl-2">
          <v-icon color="primary" large left>
          </v-icon>
          {{ $t('display/logs:schedule.title') }}
        </h2>

        <DataTablePaginated
          ref="table"
          class="ma-1"
          :headers="headers"
          icon="preview"
          @clickedButton1="showJson"
          @updateTableData="updateTable"
          :addBtn="false"
          sortBy="createdAt"
          sort-desc
          :customPanel="createPanel()"
          disableSearch
        />

      </v-col>
    </v-row>
  </div>
</template>

<script>

import DataTablePaginated from '@/modules/core/components/DataTable/DataTablePaginated';
import LogsService from '@/modules/display/services/logs-service';
import TablePanel from "@/modules/display/views/logs/TablePanel";
import DataUtils from '@/modules/core/services/data-utils';
import Log from "@/modules/display/data/log";
import Utils from '@/modules/core/services/utils';
import Vue from "vue";
import {i18n} from '@/plugins/i18next';

export default {
  name: "ScheduleTable",
  components: {
    DataTablePaginated
  },
  data() {
    return {
      filterHours: true
    };
  },
  computed: {
    headers() {
      return [
        { text: this.$t('common:last-updated-on'), value: 'createdAt' },
        { text: this.$t('display/logs:schedule.quality'), value: 'quality' },
        { text: this.$t('display/logs:schedule.runtime'), value: 'runtime' },
        { text: this.$t('display/logs:schedule.number-of-entries'), value: 'countEntries' },
        { text: this.$t('display/logs:schedule.number-of-elevators'), value: 'countElevators' }
      ]
    }
  },
  methods: {
    showJson(item) {
      this.$refs.dialogShow.initialization(item);
    },
    updateTable(options, search) {
      if (!search) search = '';

      this.$refs.table.loading = true;
      let filter = {filter24: this.filterHours};

      LogsService.readAllScheduleLogsPaginated(
        options.page - 1,
        options.itemsPerPage,
        search,
        options.sortBy,
        options.sortDesc,
        filter,
        (response) => {
          if (this.$refs.table !== undefined) {
            response.data.content = DataUtils.parseDataToObjectArray(response.data.content, Log);
            this.$refs.table.fillTableData(response.data);
          }
          this.$refs.table.loading = false;
        },
        () => {
          this.$refs.table.loading = false;
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('display/logs:schedule.title')}));
        }
      );
    },
    createPanel() {
      let TablePanelComponent = Vue.extend(TablePanel);
      let instance = new TablePanelComponent({
        i18n,
        propsData: {filterValue: this.filterHours}
      });
      instance.$on('customPanelValueUpdated', this.updateFilter);
      return instance;
    },
    updateFilter(value) {
      this.filterHours = value;
      this.$refs.table.callTableUpdate()
    }
  }
}
</script>
